import { Injectable, signal } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SidebarMenuService {
  readonly currentUrl = signal("");

  isActiveRoute = (url: string, isExact?: boolean): boolean =>
    isExact ? this.currentUrl() === url : this.currentUrl().startsWith(url);
}
